import React, { useEffect, useState } from 'react';
import JobApplicationForm from '../components/JobApplicationForm';
import API_BASE from '../utils/apiBase';

const Career = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/api/jobs.php`)
      .then(res => res.json())
      .then(data => {
        setJobs(data.jobs || []);
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-black to-gray-900 py-10 px-2 md:px-8 flex items-center justify-center" style={{ marginTop: "90px" }}>
      <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* Form Section */}
        <div className="bg-black/20 backdrop-blur-xl border border-white/20 rounded-2xl shadow-2xl p-8 flex flex-col justify-center">
          <h2 className="text-3xl font-bold text-white mb-6 text-center drop-shadow">Join Us</h2>
          <JobApplicationForm jobs={jobs} />
        </div>
        {/* Job Listings Section */}
        <div className="bg-black/20 backdrop-blur-xl border border-white/20 rounded-2xl shadow-2xl p-8">
          <h2 className="text-3xl font-bold text-white mb-6 text-center drop-shadow">Open Positions</h2>
          {loading ? (
            <div className="text-center text-blue-200">Loading...</div>
          ) : jobs.length === 0 ? (
            <div className="text-center text-gray-400">No positions available.</div>
          ) : (
            <div className="space-y-6">
              {jobs.map(job => (
                <div
                  className="bg-black/20 hover:bg-black/30 transition rounded-xl p-6 shadow flex flex-col gap-2 border border-white/10"
                  key={job.id}
                >
                  <h3 className="text-xl font-semibold text-white mb-1 drop-shadow">{job.title}</h3>
                  <div className="text-gray-200 text-sm mb-2" dangerouslySetInnerHTML={{__html: job.description}} />
                  <div className="flex flex-wrap gap-4 text-sm text-blue-100">
                    <span><span className="font-medium">Qualification:</span> {job.qualification}</span>
                    <span><span className="font-medium">Experience:</span> {job.experience}</span>
                    <span><span className="font-medium">Positions:</span> {job.positions}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Career;
